import {Injectable} from "@angular/core";
import {Cart} from "../domain/cart";
import {CartItem} from "../domain/cartitem";
import {CheckoutService} from "../checkout/checkout.service";
import {Order} from "../domain/order";
import {OrderLine, OrderLineStatus} from "../domain/orderline";
import {CacheService} from "../cache/cache.service";
import {ExchangeService} from "../exchange/exchange.service";


@Injectable({
  providedIn: 'root'
})
export class PricingService {

    constructor(protected cacheService: CacheService,
                protected exchangeService: ExchangeService,
                protected checkoutService: CheckoutService) {
    }

    public getCartTotalWithTaxes(cart: Cart) {

        let returnValue = 0;

        cart.cartItems.forEach((item: CartItem) => {
            returnValue += item.exchangePrice.price * item.quantity;
        });

        return Math.round(returnValue * 100) / 100;

    }

    public getOrderTotalWithoutTaxes(order: Order) {
        let returnValue = 0;

        order.orderLines.forEach((orderLine: OrderLine) => {
            if(orderLine.status != OrderLineStatus.REFUNDED) {
                returnValue += orderLine.exchangePrice.price * orderLine.quantity;
            }
        });

        return Math.round(returnValue * 100) / 100;
    }

    public getOrderTotalWithTaxes(order: Order) {
        let returnValue = 0;

        order.orderLines.forEach((orderLine: OrderLine) => {
            if(orderLine.status != OrderLineStatus.REFUNDED) {
                returnValue += orderLine.exchangePrice.price * orderLine.quantity;
            }
        });

        if(order.discount != null && order.discount > 0) {
            returnValue -= order.discount;
        }

        return Math.round(returnValue * 100) / 100;
    }

    public getOrderTotalWithTaxesAndShippingCost(order: Order) {
        let returnValue = this.getOrderTotalWithTaxes(order);
        return Math.round(returnValue * 100) / 100;
    }

    public getOrderTaxes(order: Order) {
        let returnValue = 0;

        //collect orderline taxes
        order.orderLines.forEach((orderLine: OrderLine) => {
            if(orderLine.status != OrderLineStatus.REFUNDED) {
                returnValue += (orderLine.exchangePrice.price) * orderLine.quantity;
            }
        });

        return Math.round(returnValue * 100) / 100;
    }

    public getCartSubtotalWithoutTaxes(cart: Cart) {

        let returnValue = 0;

        cart.cartItems.forEach((item: CartItem) => {
            returnValue += item.exchangePrice.price * item.quantity;
        });

        return Math.round(returnValue * 100) / 100;

    }

    public getCartTaxes(cart: Cart) {

        return this.getCartTotalWithTaxes(cart) - this.getCartSubtotalWithoutTaxes(cart);

    }


}
